import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';

interface HeaderProps {
  onRefresh: () => void;
}

const Header: React.FC<HeaderProps> = ({ onRefresh }) => {
  const { t } = useTranslation();

  return (
    <div className="row mb-6">
      <div className="col-8">
        <h4 className="m-0 fw-bold">{t('auditLogs.list.pageTexts.header.title')}</h4>
        <p>{t('auditLogs.list.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-4 d-flex align-items-center justify-content-end">
        <Button
          className="btn btn-outline-secondary waves-effect"
          text={t('auditLogs.list.pageTexts.header.refresh')}
          onClick={onRefresh}
        />
      </div>
    </div>
  );
};

export default Header;
